import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { VerifierCompanyInformationFormWrapperClearVerifyAdmin } from 'src/components/verifier';
import {
  UndergoReverificationConfirmationModal,
  VerifierCredentialStatusNoticeModal,
} from 'src/modals/verifier';

export const VerifierDetailCompanyInformationPageClearVerifyAdmin: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Company Information">
      <VerifierCompanyInformationFormWrapperClearVerifyAdmin />

      <UndergoReverificationConfirmationModal />
      <VerifierCredentialStatusNoticeModal />
    </DetailPageLayout>
  );
};
